import { ProjectListTitlesAndIds } from "api/queries";
import { useUserDepartments } from "hooks";
import { useState } from "react";
import { useQuery } from "urql";
import { NUMBER_OF_PROJECTS_FETCHED, REFRESH_DELAY } from "variables";

export const useFetchProjectList = () => {
  const [isTimeoutActive, setIsTimeoutActive] = useState(false);
  const { selected: selectedDepartment } = useUserDepartments();
  const [{ data, fetching, stale }, exeGetProjectsOptions] = useQuery({
    query: ProjectListTitlesAndIds,
    variables: {
      limit: NUMBER_OF_PROJECTS_FETCHED,
      page: 1,
      filters: {
        departmentId: selectedDepartment?.value || "",
      },
    },
  });

  const refetch = () => {
    setIsTimeoutActive(true);
    setTimeout(() => {
      exeGetProjectsOptions();
      setIsTimeoutActive(false);
    }, REFRESH_DELAY);
  };

  return [
    { data, fetching: isTimeoutActive || fetching, stale },
    refetch,
  ] as const;
};
